import styled from "styled-components";

import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

import { NoData } from "pro-features/components/NoData/src/NoData";

export const SIDEBAR_CLOSE_BTN_CLASS = "search-panel-close-btn";
export const SIDEBAR_COMPONENT_CLASS = "saved-search-panel";

const HEADER_AND_SEARCH_BLOCK_HEIGHT = 210;
const INDENTATION_FROM_ICON = 30;

export const StyledPanelTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px 0 20px 16px;
    ${mixins.setFontVariant("h4", colorsPalettes.carbon[500])};
    background: ${colorsPalettes.blue[75]};
`;

export const StyledSidebarContainer = styled.div`
    position: relative;
    top: 20px;

    .saved-search-panel {
        width: 462px;
        justify-content: flex-start;
    }
`;

export const SearchContainer = styled.div`
    width: 100%;
    border-radius: 3px;
    border: 1px solid ${colorsPalettes.midnight[50]};
    margin-bottom: 24px;
    .SearchInput-container .SearchInput {
        height: 40px;
        background-color: ${colorsPalettes.carbon[0]};
        border: none;
        width: calc(100% - ${INDENTATION_FROM_ICON}px);
        box-sizing: border-box;
        padding: 9px 2px 5px 50px;
        box-shadow: none;
        margin-bottom: 0px;
        &:focus {
            box-shadow: none !important;
            border: none;
        }
    }
    .SearchInput-container .SWReactIcons {
        margin-top: 5px;
    }
`;

export const SavedSearchesListContainer = styled(FlexColumn)`
    height: calc(100vh - ${HEADER_AND_SEARCH_BLOCK_HEIGHT}px);
    overflow: auto;
    gap: 8px;
`;

export const SavedSearchesBodyContainer = styled(FlexColumn)`
    padding: 24px 16px 32px 16px;
`;

export const SavedSearchesListTitle = styled.div`
    display: flex;
    ${mixins.setFontVariant("listItem1", colorsPalettes.carbon[400])};
    margin-bottom: 8px;
`;

export const StyledNoData = styled(NoData)`
    display: flex;
    margin: 62px 0;
`;

export const Overlay = styled.div<{ isOpen: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${rgba(colorsPalettes.midnight[300], 0.7)};
    z-index: 1060;
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};
`;
